import React from 'react';
import './Cosection.css';
import sampleImage from '../Images/contact.jpg'; // Replace with your image path
import { Link } from 'react-router-dom';

const Cosection = () => {
  return (
    <div className="cosection-container">
      {/* Text Section */}
      <div className="cosection-text-section">
        <h2 className="cosection-title">We're Here to Help</h2>
        <p className="cosection-description">
          Have questions or need assistance? Our team is always ready to assist
          you with your queries and ensure a seamless experience.
        </p>
        <Link to="/contact">
          <button className="cosection-contact-button">Contact Us</button>
        </Link>
      </div>

      {/* Image Section */}
      <div className="cosection-image-section">
        <img
          src={sampleImage}
          alt="Support Team"
          className="cosection-image"
        />
      </div>
    </div>
  );
};

export default Cosection;
